import axios from "axios";
import {
  getCountrySuccess,
  updateTrustPilotReviewCount,
  updateTrustPilotScore,
  updateTrustPilotSummary,
} from "./appReducer";
import config from "@Config/index";
import getUserCountry from "@Pages/Search/components/SearchList/components/TrustPilotBanner/helper";
import { registerPostHogSuperProperties } from "@Utils/posthog";

class AppDispacher {
  private dispatch;

  constructor(dispatch: any) {
    this.dispatch = dispatch;
  }

  async fetchCountryData() {
    const cachedCountry = typeof window !== "undefined" ? localStorage.getItem("country") : null;
    if (cachedCountry) {
      this.dispatch(getCountrySuccess(cachedCountry));
      registerPostHogSuperProperties().catch(() => undefined);
      return;
    }

    try {
      const data = await getUserCountry();
      if (data?.country) {
        if (typeof window !== "undefined") {
          localStorage.setItem("country", data.country);
          if (data.city) {
            localStorage.setItem("city", data.city);
          }
        }
        this.dispatch(getCountrySuccess(data.country));
        registerPostHogSuperProperties().catch(() => undefined);
      }
    } catch (error) {
      console.error("Error in fetchCountryData:", error);
    }
  }

  async fetchGlobalTrustPilotRating() {
    try {
      const { data } = await axios.get(
        `${config.API_URL}/api/v0/trustpilot_review/get_trustpilot_reviews_count`,
      );
      if (config.IS_CHINA_APP) {
        const count = Number(data?.data?.count);
        const trustScore = Number(data?.data?.trustScore);
        if (count > 0 && trustScore > 0) {
          const stars = Number(data?.data?.stars);
          this.dispatch(
            updateTrustPilotSummary({
              count,
              trustScore,
              stars: Number.isFinite(stars) && stars > 0 ? stars : undefined,
            }),
          );
        }
        return;
      }
      // eslint-disable-next-line radix
      this.dispatch(updateTrustPilotReviewCount(parseInt(data?.data?.count || "8300")));
      this.dispatch(updateTrustPilotScore(data?.data?.trustScore || 4.8));
    } catch (error) {
      if (config.IS_CHINA_APP) return;
      this.dispatch(updateTrustPilotReviewCount(8300));
    }
  }
}

export default AppDispacher;
